


<app-schedule-hold-info-multiple *ngIf="scheduleHoldsComplete &&  !creatingBookings && !creatingBookingComplete" [checkrideRefs]="checkRides" (returnToSearch)="returnToSearch()"></app-schedule-hold-info-multiple>

<div *ngFor="let checkRideRef of checkRides">
    <app-examiner-booking-creation-item [checkRideRef]="checkRideRef"></app-examiner-booking-creation-item>
</div>

<br>

<dw-message [(message)]="message"></dw-message>

<button class="btn btn-success" (click)="createBookings()" [disabled]="creatingBookings" [hidden]="creatingBookingComplete || validCheckrideCount==0" >
    <span [hidden]="creatingBookings">Create Bookings</span><span [hidden]="!creatingBookings">Creating {{validCheckrideCount}} Booking{{ validCheckrideCount > 1 ? 's' : ''}} <i class="fa fa-spinner fa-pulse fa-fw"></i></span>
</button>

<button class="btn btn-danger" (click)="close()" [hidden]="!creatingBookingComplete">Close</button>
